import { dropdownItemClass, navbarLinkClass } from '@/components/navbar-next/'
import { Button, Menu, Tooltip } from '@mantine/core'
import Link from 'next/link'
import { Icon } from '@/components/icon'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { OrganizationTypes } from '@/api/generated/model'

export function AnalyticsButton({
  organizationType,
  hasImpactReportAccess = false
}: {
  organizationType?: string
  hasImpactReportAccess?: boolean
}) {
  const isManufacturer = organizationType === OrganizationTypes.Manufacturer
  const isDistributor = organizationType === OrganizationTypes.Distributor

  return (
    <Menu shadow="md" position="bottom-start">
      <Menu.Target>
        <Button
          variant="transparent"
          c="white"
          rightSection={<Icon icon={faChevronDown} size={10} />}
        >
          Analytics
        </Button>
      </Menu.Target>
      <Menu.Dropdown className="py-2">
        <Menu.Item
          component={Link}
          href="/analytics/advanced"
          className={dropdownItemClass}
        >
          Advanced Analytics
        </Menu.Item>
        <Menu.Item
          component={Link}
          href="/analytics/unpriced-agreement-items"
          className={dropdownItemClass}
        >
          Unpriced Agreement Items
        </Menu.Item>
        {/* Distributor-only: the comparison pages' grain is one distributor's
            partnership, and the API rejects every other org type — including
            the Administrator org, so the gate is == Distributor, not
            !isManufacturer. */}
        {isDistributor && (
          <>
            <Menu.Item
              component={Link}
              href="/analytics/price-sheet-comparison"
              className={dropdownItemClass}
            >
              Price Sheet Comparison
            </Menu.Item>
            <Menu.Item
              component={Link}
              href="/analytics/spa-revision-comparison"
              className={dropdownItemClass}
            >
              SPA Revision Comparison
            </Menu.Item>
            <Menu.Item
              component={Link}
              href="/analytics/spa-pair-comparison"
              className={dropdownItemClass}
            >
              SPA Comparison
            </Menu.Item>
            <Menu.Item
              component={Link}
              href="/analytics/claim-rejection"
              className={dropdownItemClass}
            >
              Claim Rejections
            </Menu.Item>
          </>
        )}
        {!isManufacturer && (
          <Tooltip
            label="Contact sales to enable Impact Report"
            disabled={hasImpactReportAccess}
            position="right"
          >
            {hasImpactReportAccess ? (
              <Menu.Item
                component={Link}
                href="/analytics/impact-report"
                className={dropdownItemClass}
              >
                Impact Report
              </Menu.Item>
            ) : (
              <Menu.Item disabled>
                <span className="cursor-not-allowed opacity-50">
                  Impact Report
                </span>
              </Menu.Item>
            )}
          </Tooltip>
        )}
      </Menu.Dropdown>
    </Menu>
  )
}
